function formatLedgerBalance (pgRows) {
  const result = {}
  for (const row of pgRows) {
    const sku = row.sku
    const key = `product:${sku}`
    result[key] = {
      total: row.amount,
      availableTotal: row.amount,
      'field:partner-balance': row.partner_balance || 0
    }
  }
  return result
}

module.exports = { formatLedgerBalance }
